import { Description as DescriptionIcon } from '@mui/icons-material';
import useSortableData from '@/hooks/useSortableData';
import { pickUpTableColumns } from '../config';
import { IconButton } from '@mui/material';
import { PickUpVisit } from '../models';
import { Table } from '@/components';

type PickUpTableProps = {
  pickUps: PickUpVisit[];
  isLoading: boolean;
  totalItems: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
  totalPicked: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  onViewDetails: (id: string) => void;
};

const PickUpTable = ({
  pickUps,
  isLoading,
  totalItems,
  totalPages,
  currentPage,
  pageSize,
  totalPicked,
  onPageChange,
  onPageSizeChange,
  onViewDetails,
}: PickUpTableProps) => {
  const { sortedData, selectedSort, handleSort } = useSortableData({
    data: pickUps || [],
    currentPage,
  });

  const renderActions = (rowData: PickUpVisit) => (
    <IconButton
      onClick={() => onViewDetails(rowData.id)}
      size='small'
      title='Ver detalle del retiro'
      sx={{ p: 0.5 }}
    >
      <DescriptionIcon sx={{ fontSize: 30 }} color='primary' />
    </IconButton>
  );

  return (
    <div className='w-full p-5 flex flex-col bg-white rounded-lg shadow-md gap-5 border border-gray-100'>
      <div>
        <span className='text-base text-gray-600 font-medium'>
          Total retirados:{' '}
          <span className='font-bold text-base text-gray-800'>{totalPicked}</span>
        </span>
      </div>
      {pickUps?.length > 0 || isLoading ? (
        <Table
          columns={pickUpTableColumns}
          data={sortedData}
          renderActions={renderActions}
          isLoading={isLoading}
          selectedSort={selectedSort}
          handleSort={handleSort}
          pagination={{
            totalItems,
            totalPages,
            currentPage,
            rowsPerPage: pageSize,
            onPageChange,
            onRowsPerPageChange: onPageSizeChange,
          }}
        />
      ) : (
        <span className='text-gray-500 text-sm italic text-center py-10'>
          No se han encontrado visitas de retiro con los filtros actuales.
        </span>
      )}
    </div>
  );
};

export default PickUpTable;
